import {Component, inject, input, model, OnInit, output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {ArbitraryRoundComponent} from "../arbitrary-round/arbitrary-round.component";
import {ArbitraryStatus, HospitalType, SrmHospitalArbitrarySearchParam} from "../../../../../../generated-model/model";
import {AsyncPipe, NgForOf} from "@angular/common";
import {SelectZoneComponent} from "../../../../../shared/components/select-zone/select-zone.component";
import {OidcSecurityService} from "angular-auth-oidc-client";
import {SecurityService} from "../../../../../security/security.service";
import {CustomUserDataResult} from "../../../../../types/openid-connect-userinfo";
import {
  ProvinceAutocompleteComponent
} from "../../../../../shared/components/province-autocomplete/province-autocomplete.component";
import {HospitalTypeResource} from "../../../../../service/HospitalTypeResource";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {
  HospitalAutocompleteComponent
} from "../../../../../shared/components/hospital-autocomplete/hospital-autocomplete.component";
import {ArbitraryMode} from "../../new-work/new-work.component";
import {defaultBudgetYear} from "../../../../../app.constants";

@Component({
  selector: 'app-arbitrary-search',
  standalone: true,
  imports: [
    FormsModule,
    ArbitraryRoundComponent,
    NgForOf,
    SelectZoneComponent,
    ProvinceAutocompleteComponent,
    AsyncPipe,
    HospitalAutocompleteComponent
  ],
  templateUrl: './arbitrary-search.component.html',
  styleUrl: './arbitrary-search.component.scss'
})
export class ArbitrarySearchComponent implements OnInit {
  params = model.required<SrmHospitalArbitrarySearchParam>();
  output = output<boolean>();
  arbitraryStatus = Object.entries(ArbitraryStatus).map(([k, v]) => ({k, v}))
  private oidcSecurityService: OidcSecurityService = inject(OidcSecurityService);
  private hospitalTypeResource = inject(HospitalTypeResource);
  hospitalType$: Observable<HospitalType[]>
  private securityService = inject(SecurityService);
  isZone: boolean = false;
  isNhso: boolean = false;
  arbitraryMode = input.required<ArbitraryMode>();

  submit() {
    this.output.emit(true)
  }

  ngOnInit(): void {
    this.hospitalType$ = this.hospitalTypeResource.hospitalType$.pipe(map(e => e.filter(e => e.id !== '0')))
    this.initialize()
  }

  initialize() {
    this.defaultZone()
    this.defaultStatus()
    this.params().budgetYear = defaultBudgetYear()
  }

  defaultZone(){
    this.oidcSecurityService.userData$.subscribe((e: CustomUserDataResult) => {
      this.isZone = this.securityService.isAnyAuthority(e, ["zone"]);
      if (this.isZone) {
        this.params().zone = {id: e.userData?.organization?.id.padStart(2, '0')}
      }
    });
  }

  defaultStatus(){
    this.oidcSecurityService.userData$.subscribe(e => {
      this.isNhso = this.securityService.isAnyAuthority(e, ["nhso"]);
      if (this.arbitraryMode() === 'NEW') {
        this.params().arbitraryStatus = this.isNhso ? 'NHSO_DISTRICT_REPORTS' : 'NOTIFIED_BY_NHSO';
      }
      if (this.arbitraryMode() === 'TASK') {
        this.params().arbitraryStatus = this.isNhso ? 'TEAM_EXAMINED_REPORT' : 'NHSO_OPERATING_AREAS';
      }
    });
  }




  selectHospitalType() {
    delete this.params().hospitalSubType
  }

  reset() {
    this.params.set({})
    this.initialize()
  }
}
